<template>
    <div class="container-fluid pt-xl-2 pt-1 card-table-container mb-2 matchrequests-lobby">
        <div class="card">
            <div class="card-header p-1">
                <div class="row no-gutters">
                    <div class="col-6">
                        <h3>{{__('lobby.game_lobby')}}</h3>
                    </div>
                    <div class="col-6 text-right">
                        <a href="#" @click.prevent="destroyRequest()" class="btn btn-danger" v-if="logged_in_user.id == matchrequest.user_id">
                            <i class="fas fa-times-circle"></i>
                            {{__('lobby.cancel')}}
                        </a>
                        <a href="/matchrequests" class="btn btn-danger" v-if="logged_in_user.id != matchrequest.user_id">
                            <i class="fas fa-times-circle"></i>
                            {{__('lobby.leave')}}
                        </a>
                    </div>
                </div>
            </div>
            <div class="card-body  pt-xl-2 pb-xl-2 py-1 px-1">
                    <div class="row text-center no-gutters">
                        <div class="matchart col-xl-2 col-6">
                            <div class="game-option-label">{{__('lobby.game_type')}}</div>
                            <span class="badge rounded-pill bg-danger text-light p-2" v-if="matchrequest.ranked"><i class="fas fa-medal" title="Ranglistenspiel"></i></span>
                            <div class="badge-half steel-edart" v-if="matchrequest.boardtype == 0">
                                <i class="icn-kombiboard" title="Alle Boards"></i>
                                <span>{{matchrequest.matchtype.name}}</span>
                            </div>
                            <div class="badge-half steel" v-if="matchrequest.boardtype == 1">
                                <i class="icn-steelboard" title="Steel-Dart"></i>
                                <span>{{matchrequest.matchtype.name}}</span>
                            </div>
                            <div class="badge-half edart" v-if="matchrequest.boardtype == 2">
                                <i class="icn-eboard" title="E-Dart"></i>
                                <span>{{matchrequest.matchtype.name}}</span>
                            </div>
                        </div>
                        <div class="setslegs col-xl-2 col-6">
                            <div class="game-option-label">{{__('lobby.length')}}</div>
                            <div class="game-option-setslegs">{{__('lobby.sets')}}: {{matchrequest.sets}} / {{__('lobby.legs')}}: {{matchrequest.legs}}</div>
                        </div>
                        <div class="options col-xl-4 col-12">
                            <div class="game-option-label">{{__('lobby.options')}}</div>
                            <span class="badge rounded-pill bg-secondary text-light p-2 m-1" v-for="item in matchrequest.options" v-bind:key="item.name">{{__('matchform.' + item.name).replace("matchform.","")}}: {{item.value}}</span><br>
                        </div>
                        <div class="leg-options col-xl-4 col-12">
                            <div class="game-option-label">{{__('lobby.start_options')}}</div>
                            <span class="badge rounded-pill bg-warning p-2 m-1">{{__('lobby.first_leg')}}: {{getOption(matchrequest.starting_options, "starting_firstleg")}}</span>
                            <span class="badge rounded-pill bg-warning p-2 m-1">{{__('lobby.other_legs')}}: {{getOption(matchrequest.starting_options, "starting_otherlegs")}}</span>
                        </div>
                    </div>
                    <hr>
                <div class="matchrequest-players" v-if="slots">
                    <div class="matchrequest-playercard" v-for="slot, idx in slots" :key="idx">
                        <div class="label">{{idx+1}}</div>

                        <template v-if="slotStatus('myplayer', slot)">
                            <div class="player-data">
                                <div class="name">{{slot.user.player ? slot.user.player.name : ''}}</div>
                                <template v-if="slot.user.player.stats && slot.user.player.stats[matchrequest.matchtype.name]">
                                    <div class="avg" v-if="matchrequest.matchtype.name != 'Cricket'">{{__('lobby.avg3')}}: {{slot.user.player.stats[matchrequest.matchtype.name].avg3}}</div>
                                    <div class="avg" v-if="matchrequest.matchtype.name == 'Cricket'">{{__('lobby.hits_per_round')}}: {{slot.user.player.stats[matchrequest.matchtype.name].hits_round}}</div>
                                    <div class="games">{{__('lobby.played_games')}}: {{slot.user.player.stats[matchrequest.matchtype.name].all}}</div>
                                    <div class="winrate">{{__('lobby.won')}}: {{slot.user.player.stats[matchrequest.matchtype.name].percentage}}%</div>
                                </template>
                            </div>
                            <div class="buttons">
                                <!-- <a href="#" @click.prevent="changeReadyState(slot.id, true)" class="btn btn-primary" v-if="!slot.ready">
                                    <template v-if="slots.length != 1">
                                        Warten auf Spieler
                                    </template>
                                    <template v-else>
                                        Klicke hier, um das Spiel zu starten
                                    </template>
                                </a> -->
                                <a href="#" @click.prevent="changeReadyState(slot.id, false)" class="btn btn-success" v-if="slot.ready">{{__('lobby.ready')}}</a>
                            </div>
                        </template>

                        <template v-if="slotStatus('player', slot)">
                            <div class="player-data">
                                <div class="name">{{slot.user.player ? slot.user.player.name : ''}}</div>
                                <template v-if="slot.user.player.stats && slot.user.player.stats[matchrequest.matchtype.name]">
                                    <div class="avg" v-if="matchrequest.matchtype.name != 'Cricket'">{{__('lobby.avg3')}}: {{slot.user.player.stats[matchrequest.matchtype.name].avg3}}</div>
                                    <div class="avg" v-if="matchrequest.matchtype.name == 'Cricket'">{{__('lobby.hits_per_round')}}: {{slot.user.player.stats[matchrequest.matchtype.name].hits_round}}</div>
                                    <div class="games">{{__('lobby.played_games')}}: {{slot.user.player.stats[matchrequest.matchtype.name].all}}</div>
                                    <div class="winrate">{{__('lobby.won')}}: {{slot.user.player.stats[matchrequest.matchtype.name].percentage}}%</div>
                                </template>
                            </div>
                            <div class="buttons">
                                <a href="#" class="btn btn-primary" v-if="!slot.ready">{{__('lobby.waiting_for_player')}}</a>
                                <a href="#" class="btn btn-success" v-if="slot.ready">{{__('lobby.ready')}}</a>
                                <a href="#" v-if="logged_in_user.id == matchrequest.user_id" @click.prevent="removeSlot(slot.id)" class="btn btn-delete-row btn-secondary" title="Spieler entfernen"><i class="fas fa-times-circle"></i></a>
                            </div>
                        </template>

                        <template v-if="slotStatus('guest', slot)">
                            <div class="player-data">
                                <div class="name">
                                    {{__('lobby.guest')}}
                                    <input type="text" v-model="slot.guestname" placeholder="Gast" @blur="addGuestName(slot)"/>
                                </div>
                                <div class="guestname">{{__('lobby.enter_guest_name')}} </div>
                            </div>
                            <div class="buttons">
                                <a href="#" class="btn btn-success">{{__('lobby.ready')}}</a>
                                <a href="#" v-if="logged_in_user.id == matchrequest.user_id"  @click.prevent="removeSlot(slot.id)" class="btn btn-delete-row btn-secondary" title="Spieler entfernen"><i class="fas fa-times-circle"></i></a>
                            </div>
                        </template>

                        <template v-if="slotStatus('computer', slot)">
                            <div class="player-data">
                                <div class="name">
                                    {{__('lobby.computer')}}
                                    <select v-model="slot.computer_level" @change.prevent="addComputerLevel(slot)">
                                        <option :value="i" v-for="i in 10" :key="i">{{__('lobby.level')}} {{i}}</option>
                                    </select>
                                </div>
                                <div class="computerlevel">{{__('lobby.computer_level')}}:
                                </div>
                            </div>
                            <div class="buttons">
                                <a href="#" class="btn btn-success">{{__('lobby.ready')}}</a>
                                <a href="#" v-if="logged_in_user.id == matchrequest.user_id"  @click.prevent="removeSlot(slot.id)" class="btn btn-delete-row btn-secondary" title="Spieler entfernen"><i class="fas fa-times-circle"></i></a>
                            </div>
                        </template>

                        <template v-if="slotStatus('friend', slot)">
                            <div class="player-data">
                                <div class="name">{{__('lobby.invitation')}}</div>
                                <div class="friendinvite">{{__('lobby.invitation_to')}}:
                                    <select v-model="slot.friend_id" @change.prevent="addFriend(slot)">
                                        <option value="">{{__('lobby.no_invitation')}}</option>
                                        <option :value="friend.id" v-for="friend in friends" :key="friend.id">{{friend.player.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="buttons">
                                <a href="#" v-if="logged_in_user.id == matchrequest.user_id"  @click.prevent="removeSlot(slot.id)" class="btn btn-delete-row btn-secondary" title="Spieler entfernen"><i class="fas fa-times-circle"></i></a>
                            </div>
                        </template>

                        <template v-if="slotStatus('open', slot)">
                            <div class="player-data">
                                <div class="name">{{__('lobby.open_player_slot')}}</div>
                                <div class="description">{{__('lobby.waiting_for_opponent')}}</div>
                            </div>
                            <div class="buttons">
                                <a href="#" v-if="logged_in_user.id == matchrequest.user_id"  @click.prevent="removeSlot(slot.id)" class="btn btn-delete-row btn-secondary" title="Spieler entfernen"><i class="fas fa-times-circle"></i></a>
                            </div>
                        </template>

                        <template v-if="slotStatus('newplayer', slot)">
                            <div class="buttons-newplayer" v-if="logged_in_user.id == matchrequest.user_id" >
                                <a href="#" @click.prevent="changeSlotStatus(slot.id, 'friend')" class="btn btn-primary">{{__('lobby.friend')}}  <span class="subdescription" v-html="__('lobby.invite_from_friendslist')"></span></a>
                                <a href="#" @click.prevent="changeSlotStatus(slot.id, 'guest')" class="btn btn-primary">{{__('lobby.guest')}}  <span class="subdescription" v-html="__('lobby.invite_local_guest')"></span></a>
                                <a href="#" v-if="computerCheck()" @click.prevent="changeSlotStatus(slot.id, 'computer')" class="btn btn-primary">{{__('lobby.computer')}}  <span class="subdescription" v-html="__('lobby.add_computer')"></span></a>
                                <a href="#" v-else class="btn btn-primary disabled">{{__('lobby.computer')}} <span class="subdescription" v-html="__('lobby.computer_not_available')"></span></a>
                                <a href="#" @click.prevent="changeSlotStatus(slot.id, 'open')" class="btn btn-primary">{{__('lobby.open')}}
                                    <span class="subdescription" v-html="__('lobby.everyone_can_join')"></span></a>
                                <a href="#" @click.prevent="removeSlot(slot.id)" class="btn btn-delete-row btn-secondary" :title="__('lobby.remove_player')"><i class="fas fa-times-circle"></i></a>
                            </div>
                        </template>
                    </div>
                    <a href="#" class="btn btn-info btn-block add-slot" @click.prevent="addSlot()" v-if="slots.length < maxslots && logged_in_user.id == matchrequest.user_id && !myplayerready" ><i class="fas fa-plus-circle"></i> <span v-html="__('lobby.add_another_player')"></span></a>
                    <h3 v-if="myplayerready && !countdownStarted" class="text-center">{{__('lobby.game_starts_on_ready')}}</h3>
                    <h3 v-if="myplayerready && countdownStarted" class="text-center">{{__('lobby.game_starts_in')}} {{countdownTimer}}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'matchrequest_prop',
            'logged_in_user',
            'friends'
        ],
        data() {
            return {
                matchrequest: this.matchrequest_prop,
                slots: this.matchrequest_prop.playerslots,
                maxslots: 4,
                myplayerready: false,

                countdown: undefined,
                countdownTimer: 1,
                countdownStarted: false
            }
        },
        mounted() {
            Echo.join('matchrequests.' + this.matchrequest.id)
            .here((users) => {
            })
            .joining((user) => {
            })
            .leaving((user) => {
                if (this.logged_in_user.id == this.matchrequest.user_id) {
                    this.removePlayerFromSlot(user.id);
                }
            })

            Echo.channel('matchrequests.' + this.matchrequest.id)
            .listen('.readystate.changed', (e) => {
                this.matchrequest = e.matchrequest;
                this.slots = e.slots;
                this.checkIfPlayerIsReady()
            })
            .listen('.friend.canceled', (e) => {
                toastError("Einladung wurde abgelehnt");
            })
            .listen('.game.started', (e) => {
                this.matchStarted(e.match_id);
            })

            if (this.logged_in_user.id != this.matchrequest.user_id) {
                this.addUserToSlot();
            }

            if (this.logged_in_user.id == this.matchrequest.user_id && this.matchrequest.user2_id) {
                this.createChallengerSlot();
            }

            if (this.logged_in_user.id == this.matchrequest.user_id) {
                setTimeout(() => {
                    this.$root.$emit('MatchRequestLobbySendSlot', this.slots[0].id);
                    this.$root.$emit('MatchRequestLobbySlotCount', this.slots.length);
                }, 0);
            }

            this.$root.$on('LobbyStartButtonToggleReady', (data) => {
                this.changeReadyState(data.slot, data.state)
            });

            this.checkIfPlayerIsReady()
        },
        methods: {
            getOption(arr, id) {
                var option = "";
                arr.forEach(element => {
                    if (element.name == id) option = element.value;
                });
                return option;
            },
            destroyRequest() {
                axios.delete('/api/matchrequests/abort/' + this.matchrequest.id).then(() => {
                    toastError('Anfrage geloescht');
                    location.href = "/matchrequests";
                });
            },
            addSlot() {
                if (this.slots.length < this.maxslots)
                    axios.post("/matchrequests/" + this.matchrequest.id + "/addslot").then((e) => {
                        this.matchrequest = e.data;
                        this.checkIfPlayerIsReady()
                        this.$root.$emit('MatchRequestLobbySlotCount', this.slots.length);
                    })
            },
            removeSlot(id) {
                axios.post("/matchrequests/" + this.matchrequest.id + "/removeslot", {playerslot_id: id}).then((e) => {
                    this.matchrequest = e.data;
                    this.checkIfPlayerIsReady()
                    this.$root.$emit('MatchRequestLobbySlotCount', this.slots.length);
                })
            },
            changeSlotStatus(id, to) {
                axios.post("/matchrequests/" + this.matchrequest.id + "/changeslot", {playerslot_id: id, to: to}).then((e) => {
                    this.matchrequest = e.data;
                    this.checkIfPlayerIsReady()
                })
            },
            addGuestName(slot) {
                axios.post("/matchrequests/" + this.matchrequest.id + "/addguestname", {playerslot_id: slot.id, name: slot.guestname});
            },
            addComputerLevel(slot) {
                axios.post("/matchrequests/" + this.matchrequest.id + "/addcomputerlevel", {playerslot_id: slot.id, level: slot.computer_level});
            },
            addFriend(slot) {
                axios.post("/matchrequests/" + this.matchrequest.id + "/addfriend", {playerslot_id: slot.id, friend_id: slot.friend_id});
            },
            slotStatus(status, slot) {
                if (status == "myplayer" && slot.user_id != null && this.logged_in_user.id == slot.user_id) return true;
                else if (status == "guest" && slot.guest) return true;
                else if (status == "computer" && slot.computer) return true;
                else if (status == "friend" && slot.friend && slot.user_id == null) return true;
                else if (status == "open" && slot.open && slot.user_id == null) return true;
                else if (status == "newplayer" && !slot.open && !slot.computer && !slot.friend && !slot.guest && slot.user_id == null) return true;
                else if (status == "player" && slot.user_id != null && this.logged_in_user.id != slot.user_id) return true;
                return false;
            },
            changeReadyState(slot_id, newstate) {
                axios.post("/matchrequests/" + this.matchrequest.id + "/changereadystate", {user_id: this.logged_in_user.id, playerslot_id: slot_id, newstate: newstate});
            },
            addUserToSlot() {
                let userInSlot = false;
                let firstEmptySlot = null;
                let friendslot = null;
                this.slots.forEach(slot => {
                    if (slot.user_id == this.logged_in_user.id) userInSlot = true;
                    if (slot.open && slot.user_id == null && firstEmptySlot == null) firstEmptySlot = slot;
                    if (slot.friend && slot.friend_id == this.logged_in_user.id) friendslot = slot;
                });
                if (friendslot != null) {
                    axios.post("/matchrequests/" + this.matchrequest.id + "/addusertoslot", {playerslot_id: friendslot.id, user: this.logged_in_user.id});
                    setTimeout(() => {
                        this.$root.$emit('MatchRequestLobbySendSlot', friendslot.id);
                    }, 0);
                }
                else if (!userInSlot && firstEmptySlot != null) {
                    axios.post("/matchrequests/" + this.matchrequest.id + "/addusertoslot", {playerslot_id: firstEmptySlot.id, user: this.logged_in_user.id});
                    setTimeout(() => {
                        this.$root.$emit('MatchRequestLobbySendSlot', firstEmptySlot.id);
                    }, 0);

                }
            },
            removePlayerFromSlot(id) {
                this.slots.forEach(slot => {
                    if (slot.user_id == id && slot.user_id != this.logged_in_user.id) {
                        axios.post("/matchrequests/" + this.matchrequest.id + "/removeuserfromslot", {playerslot_id: slot.id});
                    }
                });
            },
            createChallengerSlot() {
                let challenger_id = this.matchrequest.user2_id;
                if (this.slots.length < this.maxslots)
                    axios.post("/matchrequests/" + this.matchrequest.id + "/addchallenger", {friend_id: challenger_id});
            },
            checkIfPlayerIsReady() {
                let allPlayersReady = this.slots.length;
                this.myplayerready = false;
                this.slots.forEach(slot => {
                    if (slot.user_id == this.logged_in_user.id && slot.ready) {
                        this.myplayerready = true;
                    }
                    if (slot.user_id != null && slot.ready) allPlayersReady -= 1;
                    if (slot.guest || slot.computer) allPlayersReady -= 1;
                })
                if (allPlayersReady == 0) {
                    this.startCountDown();
                } else {
                    clearInterval(this.countdown);
                    this.countdownStarted = false;
                    this.countdownTimer = 1;
                }
            },
            startCountDown() {
                this.countdownStarted = true;
                this.countdown = setInterval(() => {
                    this.countdownTimer -= 1;
                    if (this.countdownTimer <= 0) {
                        if (this.matchrequest.user_id == this.logged_in_user.id) {
                             axios.post('/api/matchrequests/start', {'id':this.matchrequest.id});
                        }
                        clearInterval(this.countdown);
                    }
                }, 1000)
            },
            matchStarted(match_id) {
                toastSuccess('Starte Spiel...');
                //redirect to the match page moved to screen type chooser
            },
            //temp fix for using computer only in x01
            computerCheck() {
                return this.matchrequest.matchtype.name == "x01"
            }
        }
    }
</script>
